import { Popover } from 'bootstrap';

export default class Card {
    constructor() {
        this.el = $('.card');

        if (!this.el.length) {
            return false;
        }

        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
        this.popoverList = [...popoverTriggerList].map(popoverTriggerEl => {
            let content = popoverTriggerEl.getAttribute('data-content'); //From view

            return new Popover(popoverTriggerEl, {
                html: true,
                content: content,
                customClass: 'card-popover'
            });
        });



        // Close all popovers when pressing Escape
        document.addEventListener('keydown', this.handleEscape.bind(this));
    }

    handleEscape(event) {
        if (event.key === 'Escape') {
            this.popoverList.forEach(popover => popover.hide());
        }
    }
}
